import { RefundsContainer } from 'modules/Refunds';
import { useParams } from 'react-router-dom';

type Props = {}

const Refunds = (props: Props) => {
    const { userType } = useParams();
    return (
        <RefundsContainer />
    )
}

export default Refunds  